import Header from "@commons/header";
import Column from "@components/column";
import Tab from "@components/tabs";
import React, { Fragment } from "react";
import CommonForm from "./CommonForm";
import Lenscolor from "./Lenscolor";
import useConfig from "@hooks/useConfig";
import { Helper } from "@utils/index";

const Addons = () => {
  const { lensAddonTypes } = useConfig();

  const items =
    lensAddonTypes?.map((l) => ({
      label: l,
      component: CommonForm,
      props: {
        name: Helper.toLowerCaseNoSpaces(l),
        type: l,
      },
    })) ?? [];

  return (
    <Fragment>
      <br />
      <Column>
        <Header title="Add-ons" />
        <Tab items={items} />
      </Column>
    </Fragment>
  );
};

export default Addons;
